export default __webpack_public_path__ + "static/media/decagonlight.c6996e10.svg";